import {Alert, Link, Typography} from '@mui/material'
import {If} from 'babel-plugin-jsx-control-statements'
import {FORM_ERROR} from 'final-form'
import {isError} from 'lodash'
import type {ComponentProps} from 'react'
import {useNavigate} from 'react-router'
import {z} from 'zod'
import config from '../../../../config'
import * as clientRoutes from '../../../constants/routes'
import {useAuth} from '../../../hooks/auth'
import useQueryParams from '../../../hooks/useQueryParams'
import Button from '../../containers/Button'
import {Footer, Login as VisualLogin} from '../../visual'
import DevLoginForm from './DevLoginForm'


const message = {
  EXTERNAL_SERVICE_ERROR: 'Chyba externí služby',
  INTERACTION_REQUIRED: 'Vyžadována interakce',
  LOGIN_REQUIRED: 'Vyžadováno přihlášení',
  ACCOUNT_SELECTION_REQUIRED: 'Vyžadován výběr účtu',
  CONSENT_REQUIRED: 'Vyžadován souhlas',
  INVALID_REQUEST_URI: 'Neplatné URI požadavku',
  INVALID_REQUEST_OBJECT: 'Neplatný objekt požadavku',
  REQUEST_NOT_SUPPORTED: 'Požadavek není podporován',
  REQUEST_URI_NOT_SUPPORTED: 'URI požadavku není podporováno',
  REGISTRATION_NOT_SUPPORTED: 'Registrace není podporována',
}


const Login = () => {
  const {devLogin, login} = useAuth()
  const navigate = useNavigate()
  // eslint-disable-next-line camelcase
  const [searchParams] = useQueryParams({error_code: z.string().optional()})

  const handleDevLogin: ComponentProps<typeof DevLoginForm>['onSubmit'] = async (values) => {
    const res = await devLogin(values)

    if (isError(res)) {
      return {[FORM_ERROR]: 'Špatný email nebo heslo'}
    }

    if (res.userId) {
      navigate(clientRoutes.HOME, {replace: true})
    }
  }

  const defaultMessage = 'Nastala neznámá chyba. Zkuste to znovu.'

  const errorCode = searchParams?.error_code
  const errorMessage = errorCode
    ? (errorCode in message
      ? message[errorCode as keyof typeof message]
      : defaultMessage
    ) : null
  return (
    <VisualLogin
        note={
          <Typography color="info.main" variant="caption">
            Nemáte přihlašovací údaje?&nbsp;
            <Link component="a" href="mailto:itpozadavky@ducr.cz" color="info.main" underline="always">
              Kontaktujte podporu
            </Link>
          </Typography>
        }
        footer={<Footer color="info.main" from={1997} version={config.buildId} />}
    >
      <Typography variant="subtitle1" color="primary">
        <strong>Modulární evidenční systém Drážního úřadu (MESDÚ)</strong>
      </Typography>
      {config.develLogin ? <DevLoginForm onSubmit={handleDevLogin} /> : null}
      <Button variant="contained" onClick={login}>Přihlásit</Button>
      <If condition={errorCode}>
        <Alert severity="error">{errorMessage}</Alert>
      </If>
    </VisualLogin>
  )
}

export default Login
